import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setHeaderCheckboxState } from '../../../store/searchColumns'

const useHeaderCheckbox = (api) => {
  const dispatch = useDispatch()
  const isHeaderChecked = useSelector(
    (state) => state.searchColumns.headerCheckbox,
  )
  const [isDisabled, setIsDisabled] = useState(false)

  const getTotalResult = api?.getDisplayedRowCount()

  useEffect(() => {
    if (getTotalResult > 10000) {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [getTotalResult])

  const getCurrentPageNodes = () => {
    if (!api) return []
    const currentPage = api.paginationGetCurrentPage()
    const pageSize = api.paginationGetPageSize()
    const startIndex = currentPage * pageSize
    const endIndex = startIndex + pageSize - 1
    const nodes = []

    api.forEachNode((node) => {
      if (node?.rowIndex == null) return
      if (node.rowIndex >= startIndex && node.rowIndex <= endIndex) {
        nodes.push(node)
      }
    })

    return nodes
  }

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked
    dispatch(setHeaderCheckboxState(checked))

    // Apply header checkbox only to the current page rows.
    const pageNodes = getCurrentPageNodes()
    if (!pageNodes.length) return

    if (typeof api.setNodesSelected === 'function') {
      api.setNodesSelected({
        nodes: pageNodes,
        newValue: checked,
      })
      return
    }

    pageNodes.forEach((node) => node.setSelected(checked))
  }

  return {
    isHeaderChecked,
    isDisabled,
    handleCheckboxChange,
  }
}

export default useHeaderCheckbox
